import React, { useState } from "react";
import { Button, Input } from "../components/Form";
import { BiMailSend } from "react-icons/bi";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { forgotPassword } from "../redux/features/authSlice";
import toast from "react-hot-toast";

function ForgotPassword() {
  const dispatch = useDispatch();
  const [enviado, setEnviado] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const res = await dispatch(forgotPassword(data.email));
    if (forgotPassword.fulfilled.match(res)) {
      setEnviado(true);
    } else {
      toast.error(res.payload || "No se pudo procesar el pedido.");
    }
  };

  return (
    <div className="w-full h-screen flex-colo bg-dry">
      <div className="w-full sm:w-2/5 p-8 rounded-2xl mx-auto bg-white flex-colo">
        <img
          src="/images/logomenu.png"
          alt="logo"
          className="w-48 h-16 object-contain"
        />
        {enviado ? (
          <div className="mt-6 text-center flex flex-col gap-4">
            <p className="text-sm text-black">
              Si el email está registrado, te va a llegar un correo con un enlace para
              restablecer tu contraseña. Revisá tu bandeja (y la de spam).
            </p>
            <Link to="/login" className="text-sm text-subMain">
              Volver a iniciar sesión
            </Link>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="w-full flex flex-col gap-4 mt-6"
          >
            <p className="text-sm text-textGray text-center">
              Ingresá tu email y te mandamos un enlace para restablecer tu contraseña.
            </p>
            <Input
              label="Email"
              type="email"
              color={true}
              placeholder="doctor@ejemplo.com"
              register={register("email", { required: "El email es obligatorio." })}
              error={errors.email}
            />
            <Button
              label="Enviar enlace"
              Icon={BiMailSend}
              onClick={handleSubmit(onSubmit)}
            />
            <Link to="/login" className="text-xs text-subMain text-center">
              Volver a iniciar sesión
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
